module.exports = __webpack_public_path__ + "static/media/statis.4c499ed8.svg";